module.exports = __webpack_public_path__ + "static/Gotham-ExtraLight-358ef904550cb9ab6cce46ad3964b4a4.woff";